import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Shield, Search } from "lucide-react";
import { toast } from "sonner";

export default function Warranty() {
  const [phone, setPhone] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const search = async (e) => {
    e.preventDefault();
    if (!phone) return;
    setLoading(true);
    try {
      const res = await api.get("/warranty/lookup", { params: { phone } });
      setData(res.data);
      if (!res.data.warranties.length && !res.data.bookings.length) {
        toast.message("No records found for that number");
      }
    } catch { toast.error("Lookup failed"); }
    setLoading(false);
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="warranty-page">
      <div className="overline text-[#FFB800]">Warranty & Service History</div>
      <h1 className="font-display text-4xl mt-2">Verify your protection.</h1>
      <p className="text-zinc-400 text-sm mt-3 max-w-xl">Enter the phone number used at booking to see all warranties and service history for that vehicle.</p>

      <form onSubmit={search} className="mt-8 flex gap-3 max-w-md" data-testid="warranty-form">
        <Input data-testid="warranty-phone" placeholder="+91..." value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-[#0A0A0C] border-zinc-800 h-11" />
        <button type="submit" className="btn-primary" data-testid="warranty-lookup-btn">
          <Search className="h-4 w-4" /> {loading ? "Searching..." : "Search"}
        </button>
      </form>

      {data && (
        <div className="mt-12 grid md:grid-cols-2 gap-6" data-testid="warranty-results">
          <div className="card-surface rounded-lg p-6">
            <div className="flex items-center gap-2"><Shield className="h-4 w-4 text-[#FFB800]" /><div className="overline">Warranties</div></div>
            {data.warranties.length === 0 ? (
              <div className="text-zinc-500 text-sm mt-4">No active warranties yet.</div>
            ) : (
              <ul className="mt-4 divide-y divide-zinc-900">
                {data.warranties.map((w) => (
                  <li key={w.job_id} className="py-3 text-sm">
                    <div className="flex justify-between">
                      <span>{w.service}</span>
                      <span className="font-mono text-xs text-zinc-500">{w.job_id}</span>
                    </div>
                    <div className="text-zinc-500 text-xs mt-1">{w.car} · Started {new Date(w.start_date).toLocaleDateString()}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="card-surface rounded-lg p-6">
            <div className="overline">Booking History</div>
            {data.bookings.length === 0 ? (
              <div className="text-zinc-500 text-sm mt-4">No bookings under this number.</div>
            ) : (
              <ul className="mt-4 divide-y divide-zinc-900">
                {data.bookings.map((b) => (
                  <li key={b.id} className="py-3 text-sm">
                    <div className="flex justify-between">
                      <span>{b.service_name}</span>
                      <span className="text-xs text-zinc-500">{b.date} · {b.time_slot}</span>
                    </div>
                    <div className="text-zinc-500 text-xs mt-1">{b.car_make} {b.car_model} · Ref {b.id}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
